import React, { useCallback, useState } from 'react';
import { SiteHeader } from './components/SiteHeader';
import { Article } from './components/Article';
import { RelatedNews } from './components/RelatedNews';
import { SiteFooter } from './components/SiteFooter';
import { LegalModal } from './components/LegalModal';
import { privacyPolicy, termsOfUse } from './data/legal';
import type { LegalDocument } from './data/legal';
export function App() {
  const [legalDocument, setLegalDocument] = useState<LegalDocument | null>(null);
  const closeLegal = useCallback(() => setLegalDocument(null), []);
  return <div id="top" className="min-h-full w-full bg-white font-serif text-ink" data-id="element-0" data-mp="31agn4l9h89hv">
      <SiteHeader data-id="element-1" data-mp="31cjn9y4cfj0b" />
      <main data-id="element-2" data-mp="2wka20ve6b74d">
        <Article data-id="element-3" data-mp="2wjgq7g0cxrfd" />
        <RelatedNews data-id="element-4" data-mp="2wiyvwox99na3" />
      </main>
      <SiteFooter onOpenPrivacy={() => setLegalDocument(privacyPolicy)} onOpenTerms={() => setLegalDocument(termsOfUse)} data-id="element-5" data-mp="2whx95n6vnccj" />
      <LegalModal document={legalDocument} onClose={closeLegal} data-id="element-6" data-mp="23vulg4fe8gqx" />
    </div>;
}